import * as ActionTypes from "services/state/action-types";

const SVAS_INITIAL_STATE = [
  {
    assetId: null,
    assetProductId: null,
    assetTag: "",
    assetDescription: "",
    svaAssetList: [],
    loading: false,
  },
];
export function svas(state = SVAS_INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.GET_SVAS:
      return { ...state, loading: true };

    case ActionTypes.GET_SVAS_SUCCESS:
      return {
        ...state,
        errors: false,
        data: action.payload ? action.payload.data.assetList : [],
        loading: false,
      };

    case ActionTypes.GET_SVAS_FAIL:
      return { ...state, errors: true, loading: false };

    default:
      return state;
  }
}

const INTERFACE_ONLINE_INITIAL_STATE = {};
export function interfaceOnline(
  state = INTERFACE_ONLINE_INITIAL_STATE,
  action
) {
  switch (action.type) {
    case ActionTypes.GET_SERVICE_REQUESTS:
      return { ...state, loading: true };

    case ActionTypes.GET_SERVICE_REQUESTS_SUCCESS:
      return {
        ...state,
        errors: false,
        serviceRequests: action.payload ? action.payload.data.objectList : [],
        loading: false,
      };

    case ActionTypes.GET_SERVICE_REQUESTS_FAIL:
      return { ...state, errors: true, loading: false };

    case ActionTypes.GET_REMAINING_HOURS:
      return { ...state, loading: true };

    case ActionTypes.GET_REMAINING_HOURS_SUCCESS:
      return {
        ...state,
        errors: false,
        remainingHours: action.payload ? action.payload.data.remainingHours : 0,
        loading: false,
      };

    case ActionTypes.GET_REMAINING_HOURS_FAIL:
      return { ...state, errors: true, loading: false };

    case ActionTypes.FIND_ALL_ASSETS:
      return { ...state, loading: true };

    case ActionTypes.FIND_ALL_ASSETS_SUCCESS:
      return {
        ...state,
        errors: false,
        assets: action.payload.asset,
        loading: false,
      };

    case ActionTypes.FIND_ALL_ASSETS_FAIL:
      return { ...state, errors: true, loading: false };

    case ActionTypes.SAVE_SERVICE_REQUEST:
      return { ...state, loading: true };

    case ActionTypes.SAVE_SERVICE_REQUEST_SUCCESS:
      return { ...state, errors: false, loading: false };

    case ActionTypes.SAVE_SERVICE_REQUEST_FAIL:
      return { ...state, errors: true, loading: false };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/services/state/interface/reducer.js